const VALIDATE_PATTERNS = {
    codiceFiscale: /^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$/,
    partitaIVA: /^[0-9]{11}$/,
};

/**
 * Returns if valueToBeValidated is a formally valid codice fiscale string
 * @param {String} valueToBeValidated
 *  Valid sample:
 *      'PDVMTT72H16F205Y'
 * @returns {Boolean}
 */
const validateCodiceFiscale = valueToBeValidated => {
    const codiceFiscalePattern = VALIDATE_PATTERNS.codiceFiscale;
    return codiceFiscalePattern.test(valueToBeValidated);
};

/**
 * Returns if valueToBeValidated is a formally valid partita IVA string
 * @param {String} valueToBeValidated
 *  Valid sample:
 *      '76765345632'
 * @returns {Boolean}
 */
const validatePartitaIVA = valueToBeValidated => {
    const partitaIVAPattern = VALIDATE_PATTERNS.partitaIVA;
    return partitaIVAPattern.test(valueToBeValidated);
};

export {
    VALIDATE_PATTERNS,
    validateCodiceFiscale,
    validatePartitaIVA
};